import { useState, useEffect } from "react";
import SkeletonProcess from "./SkeletonProcess.jsx";
//Para PK en concreto añadir id /api/v1/processes/2/?active=true&limit=1
function ProcessMainCard({ configuration }) {
  const [processData, setProcessData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const headers = {
    "Accept-Language": window.location.pathname.split("/")[1],
  };

  useEffect(() => {
    getProcessData();
  }, []);

  const getProcessData = async () => {
    setIsLoading(true);
    fetch(configuration.endpoint, { headers: headers })
      .then((response) => response.json())
      .then((data) => {
        if (data.results.length > 0) {
          setProcessData(data.results[0]);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  function truncateText(text, wordsMax) {
    // TODO... Trunca los tags html..
    let textTruncate = "";
    if (text !== undefined) {
      const words = text.split(" ");
      const limitWords = wordsMax;
      if (words.length <= limitWords) {
        textTruncate = text;
      } else {
        textTruncate = words.slice(0, limitWords).join(" ") + "...";
      }
    }
    return textTruncate;
  }

  useEffect(() => {
    if (!isLoading && !processData) {
      const container = document.getElementById(configuration.container);
      container?.remove();
      const sections = document.querySelectorAll(
        ".home-widgets-container > section:not(.d-none)"
      );
      if (sections.length > 0) {
        sections[0]
          .querySelector(".section__title--float")
          ?.classList.add("text-white");
        sections[0]
          .querySelector(".section__description--float")
          ?.classList.add("text-white");
      }
    }
  }, [isLoading, processData]);

  let out = null;

  if (processData) {
    out = (
      <>
        <div className="card card-border-left p-0 p-md-3 overflow-hidden">
          <div className="row">
            <div className="col-md-6 mb-2 p-md-4">
              <img
                className="img-fluid object-fit-cover h-100 w-100 p-0 rounded-3"
                src={processData?.main_image}
                alt={processData?.name}
                width="400"
                height="250"
                loading="lazy"
              />
            </div>
            <div className="col-md-6 d-flex flex-column">
              <div className="card-header">
                <div className="d-flex flex-row">
                  <i
                    className={`icon-${processData?.current_phase?.phase_type}`}
                    title={processData?.current_phase?.phase_type_display}
                  ></i>
                  <span>{processData?.current_phase?.phase_type_display}</span>
                </div>
                <div className="card-title">
                  <h3>
                    <a
                      href={processData?.url}
                      className="text-decoration-none text-primary"
                    >
                      {processData?.name}
                    </a>
                  </h3>
                </div>
              </div>
              <div className="d-none d-sm-block  card-body">
                <div
                  className="card-text"
                  dangerouslySetInnerHTML={{
                    __html: truncateText(processData?.description, 30),
                  }}
                />
              </div>
              <div className="card-footer ">
                <a href={processData?.url} className="btn btn-primary">
                  {configuration.translations.takePart}
                  <i className="fa-solid fa-arrow-right ms-3"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  return <>{isLoading ? <SkeletonProcess /> : out}</>;
}

export default ProcessMainCard;
